import { z } from "zod/v3";
import {
  DisabledTrack as ProtoDisabledTrack,
  DisabledTrack_DisabledTrackType as ProtoDisabledTrackType,
} from "@opstel/gen/knop/ui/v1/model/disabled_track_pb";
import { createSchema, ZodOutputFor } from "@opstel/query/zod-utils";
import { PlainMessage } from "@bufbuild/protobuf";

export type DisabledTrackType =
  | "Unknown"
  | "NoPower"
  | "NoMoveNoMaterial"
  | "NoMove"
  | "NoMoveNoPower"
  | "Reservation";

export interface DisabledTrack {
  trackCode: string;
  type: DisabledTrackType;
}

type ValidatedDisabledTrackType = Exclude<ProtoDisabledTrackType, ProtoDisabledTrackType.UNKNOWN>;
function transformDisabledTrackTypeEnum(type: ValidatedDisabledTrackType): DisabledTrackType {
  const mapping: { [key in ValidatedDisabledTrackType]: DisabledTrackType } = {
    [ProtoDisabledTrackType.NO_POWER]: "NoPower",
    [ProtoDisabledTrackType.NO_MOVE_NO_MATERIAL]: "NoMoveNoMaterial",
    [ProtoDisabledTrackType.NO_MOVE]: "NoMove",
    [ProtoDisabledTrackType.NO_MOVE_NO_POWER]: "NoMoveNoPower",
    [ProtoDisabledTrackType.RESERVATION]: "Reservation",
  };
  return mapping[type];
}

export const disabledTrackSchema = createSchema<DisabledTrack, PlainMessage<ProtoDisabledTrack>>({
  trackCode: z.string().min(1, { message: "DisabledTrack trackCode should not be empty" }),
  type: z
    .nativeEnum(ProtoDisabledTrackType)
    .refine((val) => val !== ProtoDisabledTrackType.UNKNOWN, {
      message: "DisabledTrack type should not be unknown",
    })
    .transform(transformDisabledTrackTypeEnum),
}) satisfies ZodOutputFor<DisabledTrack>;
